import React from 'react'
import {component_tool} from "@/tool";

let {WizDataTable, WizIcon, WizButton, WizDivider} = component_tool;

export default (self) => {
  return [
    {
      title: '组织名称',
      dataIndex: 'orgPathName',
      width: 150,
      key: 'orgPathName',
    },
    {
      title: '组织编码',
      dataIndex: 'orgCode',
      width: 120,
      key: 'orgCode',
    },
    {
      title: '岗位名称',
      dataIndex: 'positionName',
      width: 100,
      key: 'positionName',
    },
    {
      title: '任职状态',
      dataIndex: 'jobState',
      width: 100,
      align: 'center',
      key: 'jobState',
      render: (text) => {
        if (text === 0) {
          return "离职"
        } else {
          return "在职"
        }
      },
    },
    {
      title: '生效日期',
      dataIndex: 'hireTime',
      width: 150,
      key: 'hireTime',
    },
    {
      title: '最新修改时间',
      dataIndex: 'updateTime',
      width: 150,
      key: 'updateTime',
    },
  ]
}
